module.exports = __webpack_public_path__ + "img/edge_nature_vallee_gorge.bff8e89b.svg";